<template>
  <div class="CampusRank">
    <div id="CampusRank"></div>
  </div>
</template>

<script>
import chartMixin from '../chartMixin';
import { mapActions } from 'vuex';

export default {
  name: 'CampusRankChart',
  mixins: [chartMixin],
  props: {
    changeCampusHandle: { type: Function },
    updateCampusName: { type: Function },
    showOtherNameHandle: { type: Function },
  },
  data() {
    let total = this.data.reduce((count, item) => count + item.count, 0);
    return {
      chart: null,
      today: this.$formatDate(new Date(), 'yyyy-MM-dd'),
      total: total,
      topTen: 0,
      other: 0,
      percentDom: null,
      areaNameDom: null,
      SelectedDataIndex: null,
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = new G2.Chart({
        container: 'CampusRank',
        forceFit: true,
        height: this.height - 30,
        padding: [0, 249, 0, 0],
      });
      this.chart.source(this.data);
      this.chart.coord('theta', {
        radius: 0.9,
        innerRadius: 0.75,
      });
      this.chart.tooltip(false);
      // 图例
      this.chart.legend({
        position: 'right-center',
        marker: 'square',
        clickable: false,
        offsetX: 2,
        useHtml: true,
        containerTpl: `
         <div class="g2-legend">
          <ul class="g2-legend-list legend-CampusRank" style="list-style-type:none;margin:0;padding:0;"></ul>
         </div>`,
        itemTpl: (value, color, checked, index) => {
          const obj = this.data[index];
          checked = checked ? 'checked' : 'unChecked';
          let price = this.$formatPrice(obj.count);
          return `
            <li
              class="g2-legend-list-item item-${index} ${checked}"
              data-value="${value}"
              data-color=${color}
              data-index=${index}
              style="cursor: pointer;font-size:14px;width:100%;"
            >
              <i
                class="g2-legend-marker"
                style="display:inline-block;margin-right:10px;background-color:${color};"
              ></i>
              <span class="g2-legend-text" title="${value}">${value}： </span>
              <span class="g2-legend-price">${price}</span>元
            </li>
            `;
        },
        'g2-legend': {
          width: '244px',
          'max-width': '244px',
          'max-height': this.height - 30 + 'px',
        },
        'g2-legend-list-item': {
          color: '#333',
        },
        'g2-legend-marker': {
          width: '10px',
          height: '5px',
          borderRadius: 'none',
        },
      });
      // 坐标系及着色
      this.chartGeom = this.chart
        .intervalStack()
        .position('count')
        .color('areaName', [
          '#ff3a34',
          '#4e82fb',
          '#fb774e',
          '#ffc934',
          '#41bf52',
          '#9b50ff',
          '#94de70',
          '#b5593d',
          '#fe8787',
          '#254eae',
          '#2f4554',
        ]);

      // 辅助元素
      this.chart.guide().html({
        position: ['50%', '50%'],
        html: `<div style="color:#333;font-size: 20px;text-align: center;width: 4em;">
            <span class="CampusRank-percent">0.00</span>%<br>
          </div>`,
        alignX: 'middle',
        alignY: 'middle',
      });
      this.chart.render();
      this.chart.on('interval:click', this.clickHandle);
    },
    updateData() {
      if (this.data.length) {
        this.total = this.data.reduce((count, item) => count + item.count, 0);
        if (this.data.length === 10) {
          this.other = this.data[this.data.length - 1].count;
          this.topTen = this.total - this.other;
        } else {
          this.other = 0;
          this.topTen = this.total;
        }
        let data = this.SelectedDataIndex;

        this.chartGeom.setSelected(this.data[0]);
        this.changeSelected(this.data[0]);
        this.updateCampusName(this.data[0]);
        this.SelectedDataIndex = this.data[0];
        this.bindClickLegendHandle();
      } else {
        this.updateCampusName();
        this.SelectedDataIndex = null;
      }
    },
    clickHandle(ev) {
      let data = ev.data._origin;
      console.log(data);

      if (this.SelectedDataIndex.areaId !== data.areaId) {
        this.SelectedDataIndex = data;
        this.changeSelected(data);
        if (data.areaId) {
          this.changeCampusHandle(data);
        } else {
          this.showOtherNameHandle();
        }
      } else {
        let selected = this.chartGeom._getSelectedShapes();

        if (selected && selected.length) {
          this.chartGeom.clearActivedShapes();
          this.chartGeom.clearSelected();
        } else {
          this.chartGeom.setSelected(data);
        }
      }
    },
    bindClickLegendHandle() {
      let ulDom = document.querySelector('.legend-CampusRank');
      ulDom.removeEventListener('click', this.clickLegendHandle);
      ulDom.addEventListener('click', this.clickLegendHandle);
    },
    clickLegendHandle(ev) {
      let liDom = null;
      if (ev.target.tagName === 'LI') {
        liDom = ev.target;
      } else {
        liDom = ev.target.parentElement;
      }
      const index = Number(liDom.dataset.index);
      if (isNaN(index)) {
        return;
      }

      // this.chart.eachShape(function(data, shape, gemo) {
      //   console.log(gemo);
      // });

      this.chartGeom.clearActivedShapes();

      const data = this.data[index];
      if (this.SelectedDataIndex.areaId !== data.areaId) {
        this.SelectedDataIndex = data;
        this.chartGeom.setSelected(data);
        this.changeSelected(data);
        if (data.areaId) {
          this.changeCampusHandle(data);
        } else {
          this.showOtherNameHandle();
        }
      }
    },
    changeSelected(data) {
      this.percentDom = document.querySelector('.CampusRank-percent');
      // this.areaNameDom = document.querySelector('.CampusRank-areaName');
      if (this.percentDom) {
        if (this.total === 0) {
          this.percentDom.innerHTML = '0.00';
        } else {
          this.percentDom.innerHTML = ((data.count / this.total) * 100).toFixed(
            2
          );
        }
      }
      // if (this.areaNameDom) {
      //   this.areaNameDom.innerHTML = data.areaName;
      // }
    },
  },
};
</script>

<style lang="scss">
.CampusRank {
  position: relative;
  .CampusRank-title {
    font-size: 16px;
    text-align: center;
    padding-bottom: 12px;
  }
  .CampusRank-legend {
    position: absolute;
    width: 160px;
    transform: translateY(-50%);
    line-height: 30px;
    top: 50%;
    right: 0;
  }
  .g2-legend-text {
    display: inline-block;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  .g2-legend-price {
    display: inline-block;
    width: 90px;
    text-align: right;
  }
}
</style>
